export default {"src":"/_next/static/media/SortDark.1c69cf7d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};